var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',{staticClass:"pa-2"},[_vm._v("\n    Reporting\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }